var styles = {"container":"navkit__ProfileIcon__container","profileIcon":"navkit__ProfileIcon__profileIcon","profileImage":"navkit__ProfileIcon__profileImage","iconLabel":"navkit__ProfileIcon__iconLabel","businessUnit":"navkit__ProfileIcon__businessUnit","keyIcon":"navkit__ProfileIcon__keyIcon","noBackgroundColor":"navkit__ProfileIcon__noBackgroundColor"};

export { styles as default };
